/* =========================================================
   TP - Compra rápida (pop-up global) <tp-quick-buy>
   Revisão de 08/10/2026. Análise que a orientou:
   Documents\claude\popup-compra-rapida\analise-pdps.md

   COMO ABRE
   - "+" do card (.tp-pcf__quick-buy) ou [data-tp-qb-open] (carrinho): lê o
     JSON do card (.tp-pcf__data). Se o card for KIT (.tp-pcf__seq-data), abre
     em passos, uma peça por vez.
   - [data-tp-qb-sequence] ("Compre o look completo"): passos a partir do
     .tp-qb__seq-data do bloco.
   - API: el.open(dados, talaoVersao) e el.openSequence({kitName, property,
     steps, versoes}).

   O QUE CADA PASSO GUARDA (this.passos[i])
   - hub:    o produto cuja FILEIRA DE CORES está na tela. É quem abriu o pop-up,
             ou a versão para a qual a cliente trocou.
   - data:   o produto que está sendo comprado agora. É o hub, ou o produto da
             COR LIGADA (ex.: abriu na LipLegging com Bolso e tocou no Branco →
             data = LipLegging Branca, hub continua a com Bolso, e a fileira não
             muda de lugar debaixo do dedo).
   - versao: talão do seletor com/sem bolso (do hub).

   DADOS LEVES E COMPLETOS
   O card manda o produto sem tabela, medidas da peça e modelos (`leve`). Ao
   abrir, o pop-up busca o produto completo em
   /products/<handle>?section_id=tp-qb-data e guarda em cache por handle. A
   mesma busca serve a troca de versão e a cor ligada.

   FOTOS DA COR
   Como na PDP: a galeria tem todas as fotos e escolher uma cor ROLA até a
   primeira foto dela (mostrarCor). De que cor é cada foto (coresDasFotos):
   1. foto com o nome de uma cor no texto alternativo → é daquela cor;
   2. foto sem texto → é da cor cuja foto de variante veio por último antes dela
      (as fotos ficam agrupadas por cor no admin);
   3. cor sem foto nenhuma → a galeria fica onde está.
   ========================================================= */
(function () {
  if (customElements.get('tp-quick-buy')) return;

  /* Comparação de cor/tamanho entre produtos: a mesma peça é "Café" num e
     "Cafe" no outro. Mapa explícito em vez de range de diacríticos em regex —
     o range já saiu do editor como bytes crus uma vez. Gêmeo do que existe em
     tp-kit.js; se mexer aqui, mexa lá. */
  var ACENTOS = {
    'á': 'a', 'à': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a',
    'é': 'e', 'è': 'e', 'ê': 'e',
    'í': 'i', 'ì': 'i', 'î': 'i',
    'ó': 'o', 'ò': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
    'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
    'ç': 'c', 'ñ': 'n'
  };

  function normaliza(s) {
    var t = String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' ');
    var saida = '';
    for (var i = 0; i < t.length; i++) saida += ACENTOS[t.charAt(i)] || t.charAt(i);
    return saida;
  }

  // Item de `lista` equivalente a `alvo`, já com a grafia da lista.
  function equivalente(lista, alvo) {
    if (alvo == null) return null;
    var n = normaliza(alvo);
    for (var i = 0; i < lista.length; i++) {
      if (normaliza(lista[i]) === n) return lista[i];
    }
    return null;
  }

  /* Raiz da cor para achar no texto da foto: "Preto" casa "preta", "Branco"
     casa "branca". Só a ÚLTIMA vogal sai, e só em nome de uma palavra — "Azul
     Marinho" fica inteiro. */
  function raizCor(nome) {
    var n = normaliza(nome);
    if (n.indexOf(' ') === -1 && n.length > 4) n = n.replace(/[oa]$/, '');
    return n;
  }

  /* Cor de fundo da bolinha pelo NOME, por baixo da imagem da amostra. A
     amostra vem de <cor>.png em Arquivos, e quando o arquivo não existe (era o
     caso do branco.png) a bolinha ficava vazia. Mesma tabela do tp-oferta-b.js,
     mais as cores das outras peças. */
  var HEX = {
    preto: '#1a1a1a', bosque: '#2e4a3d', cereja: '#c50b39', cafe: '#7b4a2d',
    'azul marinho': '#1d2a44', marinho: '#1d2a44', 'verde oliva': '#6b7f5a',
    branco: '#f7f7f5', bege: '#d9c7b2', vinho: '#5a1f2b', rosa: '#e8a5b3',
    cinza: '#8a8a8a', azul: '#2c3e6b', 'azul claro': '#a9c1d9', acai: '#4b1f3a',
    'verde militar': '#4b5536', verde: '#5f7a5a', grafite: '#4a4c4f',
    tapioca: '#e6dccb', terracota: '#b5603f', 'preto canelado': '#1a1a1a',
    'verde canelado': '#5f7a5a'
  };

  function hexDaCor(nome) {
    return HEX[normaliza(nome)] || '#d8d6cf';
  }

  function escapaHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function semUrlQuery(u) {
    return String(u || '').split('?')[0];
  }

  // Centavos → "R$ 1.234,56" (o mesmo formato do money_with_currency sem "BRL").
  function dinheiro(c) {
    var v = Math.round(c);
    var reais = Math.floor(v / 100);
    var cent = String(v % 100);
    if (cent.length < 2) cent = '0' + cent;
    var r = String(reais).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + r + ',' + cent;
  }

  // Centavos a partir do texto "R$ 1.234,56" (comparePrice só vem em texto).
  function centavosDe(txt) {
    if (txt == null) return null;
    var d = String(txt).replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : null;
  }

  /* "P (36 - 38)" → { main: "P", sub: "36–38" }. Rótulo longo numa pílula só
     quebrava a fileira em duas linhas; assim cabem 5 por linha no celular. */
  function partesTamanho(rotulo) {
    var t = String(rotulo || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^(.+?)\s*\((.+)\)\s*$/);
    if (!m) return { main: t, sub: '' };
    // – = travessão curto; escrito em escape para não depender da codificação.
    var sub = m[2].replace(/\s*[-–]\s*|\s+a\s+/g, '–').replace(/\s+/g, ' ');
    return { main: m[1], sub: sub };
  }

  class TpQuickBuy extends HTMLElement {
    constructor() {
      super();
      this.mode = 'single';
      this.passos = [];
      this.stepIndex = 0;
      this.collected = [];
      this.kitName = '';
      this.kitProperty = '_kit';
      this.cache = {};          // handle -> dados completos
      this.buscas = {};         // handle -> Promise em andamento
      this.selectedColor = null;
      this.selectedSize = null;
      this.ocupado = false;
      this.gatilho = null;
      this.onKeydown = this.onKeydown.bind(this);
      // Entradas que o pop-up pôs no histórico: 1 = pop-up aberto, 2 = guia de medidas por cima.
      this.niveisHist = 0;
      this.ignorarPop = false;
    }

    connectedCallback() {
      var q = (s) => this.querySelector(s);
      this.overlay = q('[data-qb-overlay]');
      this.sheet = q('.tp-qb__sheet');
      this.scrollEl = q('[data-qb-scroll]');
      this.trackEl = q('[data-qb-track]');
      this.thumbsEl = q('[data-qb-thumbs]');
      this.navPrev = q('[data-qb-nav="-1"]');
      this.navNext = q('[data-qb-nav="1"]');
      this.kitEl = q('[data-qb-kit]');
      this.backBtn = q('[data-qb-back]');
      this.backLabel = q('[data-qb-back-label]');
      this.stepEl = q('[data-qb-step]');
      this.titleEl = q('[data-qb-title]');
      this.detailsEl = q('[data-qb-details]');
      this.priceMainEl = q('[data-qb-price-main]');
      this.priceCompareEl = q('[data-qb-price-compare]');
      this.parcEl = q('[data-qb-parc]');
      this.cupomEl = q('[data-qb-cupom]');
      this.versaoEl = q('[data-qb-versao]');
      this.colorGroup = q('[data-qb-color-group]');
      this.colorsEl = q('[data-qb-colors]');
      this.colorCurrentEl = q('[data-qb-color-current]');
      this.sizeGroup = q('[data-qb-size-group]');
      this.sizesEl = q('[data-qb-sizes]');
      this.hintEl = q('[data-qb-hint]');
      this.helpBtn = q('[data-qb-help-open]');
      this.helpEl = q('[data-qb-help]');
      this.helpTabsEl = q('[data-qb-help-tabs]');
      this.helpBodyEl = q('[data-qb-help-body]');
      this.variantInput = q('[data-qb-variant-id]');
      this.addBtn = q('[data-qb-add]');
      this.addLabel = q('[data-qb-add-label]');
      this.errorWrap = q('.tp-qb__error');
      this.errorEl = q('[data-qb-error]');

      // Abrir pelo "+" do card ou por [data-tp-qb-open] (delegação global).
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.tp-pcf__quick-buy, [data-tp-qb-open]');
        if (!trigger) return;
        const card = trigger.closest('[data-tp-pcf]');
        if (!card) return;
        e.preventDefault();
        this.gatilho = trigger;

        // Kit / compre-e-ganhe: o card traz a sequência das peças.
        const seqEl = card.querySelector('.tp-pcf__seq-data');
        if (seqEl) {
          try {
            this.openSequence(JSON.parse(seqEl.textContent));
            return;
          } catch (err) {
            console.error('[tp-quick-buy] JSON de sequência inválido no card', err);
          }
        }

        const dataEl = card.querySelector('.tp-pcf__data');
        if (!dataEl) return;
        let versao = null;
        const vEl = card.querySelector('.tp-pcf__versao-data');
        if (vEl) {
          try { versao = JSON.parse(vEl.textContent); } catch (err) { versao = null; }
        }
        try {
          this.open(JSON.parse(dataEl.textContent), versao);
        } catch (err) {
          console.error('[tp-quick-buy] JSON inválido do card', err);
        }
      });

      // "Compre o look completo" da PDP: um botão, várias peças em sequência.
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-tp-qb-sequence]');
        if (!trigger) return;
        e.preventDefault();
        const root = trigger.closest('.tp-look') || trigger.parentElement;
        const dataEl = root && root.querySelector('.tp-qb__seq-data');
        if (!dataEl) return;
        this.gatilho = trigger;
        try {
          this.openSequence(JSON.parse(dataEl.textContent));
        } catch (err) {
          console.error('[tp-quick-buy] JSON de sequência inválido', err);
        }
      });

      /* "VOLTAR" DO NAVEGADOR / GESTO DO CELULAR FECHA O POP-UP (09/10/2026).
         Antes o voltar saía da coleção e a cliente perdia o lugar na lista
         (recomendação da Baymard para compra rápida). Abrir empilha uma entrada no
         histórico, com a MESMA URL; o voltar desempilha e cai aqui. Com o guia de
         medidas aberto, o primeiro voltar fecha só o guia. Fechar pelo X, pelo
         fundo, pelo Esc ou ao adicionar tira as entradas que o pop-up pôs. */
      window.addEventListener('popstate', () => {
        if (this.ignorarPop) { this.ignorarPop = false; return; }
        if (this.niveisHist <= 0) return;
        this.niveisHist--;
        if (this.helpEl && !this.helpEl.hidden) this.fecharGuia(true);
        else if (this.classList.contains('is-open')) this.close(true);
      });

      this.overlay.addEventListener('click', () => this.close());
      this.querySelectorAll('[data-qb-close]').forEach((b) => b.addEventListener('click', () => this.close()));

      this.colorsEl.addEventListener('click', (e) => {
        const sw = e.target.closest('.tp-qb__color');
        if (sw) this.escolherCor(sw);
      });
      this.sizesEl.addEventListener('click', (e) => {
        const sz = e.target.closest('.tp-qb__size');
        if (sz) this.selectSize(sz.dataset.value); // AVISE-ME (19/10/2026): esgotado também escolhe
      });
      this.versaoEl.addEventListener('click', (e) => {
        const b = e.target.closest('[data-qb-versao-trocar]');
        if (b) this.trocarVersao(b);
      });

      // Galeria: setas (desktop) e miniaturas.
      [this.navPrev, this.navNext].forEach((b) => {
        b.addEventListener('click', () => this.passarFoto(parseInt(b.dataset.qbNav, 10)));
      });
      this.thumbsEl.addEventListener('click', (e) => {
        const t = e.target.closest('.tp-qb__thumb');
        if (t) this.irParaFoto(parseInt(t.dataset.i, 10), true);
      });
      let rolando = null;
      this.trackEl.addEventListener('scroll', () => {
        clearTimeout(rolando);
        rolando = setTimeout(() => this.marcarFotoAtual(), 60);
      }, { passive: true });

      /* O botão nunca fica cinza esperando o tamanho: botão desabilitado não
         explica nada. Sem tamanho, o clique leva até os tamanhos e avisa.
         Captura + stopImmediatePropagation: o submit do <product-form> nem
         chega a disparar. No modo sequência, o clique avança a peça. */
      this.addBtn.addEventListener('click', (e) => {
        const variant = this.matchVariant();
        // AVISE-ME (19/10/2026): tamanho esgotado escolhido -> o botão abre o pop-up de e-mail
        if (variant && !variant.available) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const item = (this.data.title || '') + ' (' + [this.selectedColor, this.selectedSize].filter(Boolean).join(' / ') + ')';
          if (window.tpAviseMe) window.tpAviseMe.abrir({ variantId: variant.id, item: item, botao: this.addBtn, rotuloEl: this.addLabel });
          return;
        }
        if (!variant || !variant.available) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.pedirTamanho();
          return;
        }
        if (this.mode === 'sequence') {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.avancar();
        }
      }, true);

      this.backBtn.addEventListener('click', () => this.voltar());

      // Guia de medidas
      this.helpBtn.addEventListener('click', () => this.abrirGuia());
      this.querySelectorAll('[data-qb-help-close]').forEach((b) => b.addEventListener('click', () => this.fecharGuia()));
      this.helpTabsEl.addEventListener('click', (e) => {
        const t = e.target.closest('[data-qb-aba]');
        if (t) this.mostrarAba(t.dataset.qbAba);
      });

      // Fecha quando o add de uma peça termina (o product-form publica cartUpdate).
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          if (this.mode === 'single' && this.classList.contains('is-open')) this.close();
        });
      }
    }

    /* ---------------- Abrir / fechar ---------------- */
    open(data, versao) {
      this.mode = 'single';
      this.galeriaAtual = null;
      this.ocupado = false;
      this.kitName = '';
      this.collected = [];
      this.passos = [this.novoPasso(data, versao)];
      this.stepIndex = 0;
      this.mostrarPasso(0);
      this.showSheet();
    }

    openSequence(seq) {
      if (!seq || !seq.steps || !seq.steps.length) return;
      this.mode = 'sequence';
      this.ocupado = false;
      this.galeriaAtual = null;
      const versoes = seq.versoes || [];
      this.passos = seq.steps.map((d, i) => this.novoPasso(d, versoes[i]));
      this.kitName = seq.kitName || '';
      this.kitProperty = seq.property || '_kit';
      this.collected = [];
      this.stepIndex = 0;
      this.mostrarPasso(0);
      this.showSheet();
    }

    novoPasso(data, talaoExterno) {
      const versao = data.versao && data.versao.handleAlt
        ? data.versao
        : (talaoExterno && talaoExterno.handleAlt ? talaoExterno : null);
      if (data.handle) this.guardar(data);
      return { hub: data, data: data, versao: versao };
    }

    get passo() {
      return this.passos[this.stepIndex];
    }

    get data() {
      return this.passo ? this.passo.data : null;
    }

    /* A entrada leva os mesmos parâmetros de filtro da página: o facets.js do
       tema também escuta o voltar e, sem `searchParams` no estado, redesenharia
       a grade achando que o filtro mudou. */
    empilharHistorico() {
      try {
        const atual = history.state && typeof history.state === 'object' ? history.state : {};
        const estado = Object.assign({}, atual, { tpQb: (this.niveisHist || 0) + 1 });
        if (estado.searchParams === undefined) estado.searchParams = location.search.slice(1);
        history.pushState(estado, '');
        this.niveisHist++;
      } catch (e) { /* sem histórico: o pop-up segue funcionando, só o voltar não fecha */ }
    }

    // Tira do histórico as entradas do pop-up quando ele fecha por outro caminho.
    desempilharHistorico(quantas) {
      const n = Math.min(quantas, this.niveisHist);
      if (n <= 0) return;
      this.niveisHist -= n;
      this.ignorarPop = true;
      try { history.go(-n); } catch (e) { this.ignorarPop = false; }
    }

    showSheet() {
      if (!this.classList.contains('is-open')) this.empilharHistorico();
      this.hidden = false;
      void this.offsetWidth; // reflow p/ a transição
      this.classList.add('is-open');
      document.body.classList.add('tp-qb-open');
      document.addEventListener('keydown', this.onKeydown);
      this.sheet.focus({ preventScroll: true });
      // rAF não roda em aba escondida; o setTimeout cobre esse caso.
      const aoAparecer = () => {
        if (this.fotoPendente != null) this.irParaFoto(this.fotoPendente, false);
        else this.marcarFotoAtual();
      };
      requestAnimationFrame(aoAparecer);
      setTimeout(aoAparecer, 60);
    }

    close(porHistorico) {
      this.fecharGuia(true);
      if (!porHistorico) this.desempilharHistorico(this.niveisHist);
      this.classList.remove('is-open');
      document.body.classList.remove('tp-qb-open');
      document.removeEventListener('keydown', this.onKeydown);
      setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 400);
      if (this.gatilho && document.contains(this.gatilho)) {
        try { this.gatilho.focus({ preventScroll: true }); } catch (e) { /* nada */ }
      }
    }

    onKeydown(e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!this.helpEl.hidden) this.fecharGuia();
      else this.close();
    }

    /* ---------------- Dados completos (cache por handle) ---------------- */
    // Guarda um produto já completo (não leve) para não buscar de novo.
    guardar(d) {
      if (d && d.handle && !d.leve && !this.cache[d.handle]) this.cache[d.handle] = d;
    }

    buscarProduto(handle) {
      if (!handle) return Promise.reject(new Error('sem handle'));
      if (this.cache[handle]) return Promise.resolve(this.cache[handle]);
      if (this.buscas[handle]) return this.buscas[handle];

      const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      let url = raiz + 'products/' + encodeURIComponent(handle) + '?section_id=tp-qb-data';
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url += '&preview_theme_id=' + encodeURIComponent(preview);

      const p = fetch(url)
        .then((r) => {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const el = doc.querySelector('[data-tp-qb-data]');
          if (!el) throw new Error('seção tp-qb-data não veio na resposta');
          const dados = JSON.parse(el.textContent);
          this.cache[handle] = dados;
          return dados;
        })
        .finally(() => { delete this.buscas[handle]; });
      this.buscas[handle] = p;
      return p;
    }

    /* Ao abrir: completa o produto da tela (para o guia de medidas) e já
       deixa à mão a outra versão e a cor ligada, que são um toque de distância. */
    preCarregar() {
      const ps = this.passo;
      if (!ps) return;
      const handles = [];
      const d = ps.data;
      if (d.leve && d.handle) handles.push(d.handle);
      if (d.guiaHandle) handles.push(d.guiaHandle);
      if (ps.hub.corLigada && ps.hub.corLigada.handle) handles.push(ps.hub.corLigada.handle);
      if (ps.versao && ps.versao.handleAlt) handles.push(ps.versao.handleAlt);
      handles.forEach((h) => { this.buscarProduto(h).catch(() => {}); });
    }

    /* ---------------- Passo atual ---------------- */
    mostrarPasso(i, selecao) {
      this.stepIndex = i;
      this.clearError();
      this.fecharGuia();
      this.atualizarKit();
      this.aplicarProduto(selecao || null);
      this.scrollEl.scrollTop = 0;
      this.preCarregar();
    }

    atualizarKit() {
      const seq = this.mode === 'sequence' && this.passos.length > 1;
      this.kitEl.hidden = !seq;
      this.classList.toggle('is-seq', seq);
      if (!seq) return;
      const n = this.passos.length;
      // O nome da peça já está logo abaixo, no título; aqui só a posição.
      this.stepEl.textContent = 'Peça ' + (this.stepIndex + 1) + ' de ' + n;
      const anterior = this.stepIndex > 0 ? this.collected[this.stepIndex - 1] : null;
      this.backBtn.hidden = !anterior;
      if (anterior) {
        const partes = [anterior.color, anterior.size].filter(Boolean).join(' · ');
        this.backLabel.textContent = 'Peça ' + this.stepIndex + (partes ? ': ' + partes : '');
      }
    }

    /* Popula a tela a partir do produto do passo. `selecao` = {color, size}
       a tentar manter (troca de versão, cor ligada, voltar no kit). */
    aplicarProduto(selecao) {
      const d = this.data;
      this.colorIndex = typeof d.colorIndex === 'number' ? d.colorIndex : -1;
      this.sizeIndex = -1;
      const optCount = (d.optionNames || []).length;
      for (let k = 0; k < optCount; k++) {
        if (k !== this.colorIndex) { this.sizeIndex = k; break; }
      }
      this.singleVariant = d.variants && d.variants.length === 1;
      this.selectedColor = null;
      this.selectedSize = null;
      this.hintEl.hidden = true;

      this.titleEl.textContent = d.title || '';
      this.titleEl.href = d.url || '#';
      this.detailsEl.href = d.url || '#';
      if (this.mode === 'sequence') this.atualizarKit();

      this.buildVersao();
      this.buildColors();
      this.buildSizes();
      this.atualizarBotaoGuia();

      // Cor: a pedida, senão a do card, senão a 1ª disponível.
      if (this.colorIndex >= 0) {
        const nomes = (d.colors || []).map((c) => c.name);
        let cor = selecao && selecao.color ? equivalente(nomes, selecao.color) : null;
        if (!cor && d.corInicial) cor = equivalente(nomes, d.corInicial);
        // Cor esgotada só fica se a cliente tocou nela (forcar); senão abre na 1ª disponível.
        if (cor && !this.corDisponivel(cor) && !(selecao && selecao.forcar)) cor = null;
        if (!cor) cor = this.firstAvailableColor();
        this.selectColor(cor);
      } else {
        this.buildGallery(this.data);
      }

      if (selecao && selecao.size && this.sizeIndex >= 0) {
        const tam = equivalente(this.listaTamanhos(), selecao.size);
        if (tam && this.isComboAvailable(this.selectedColor, tam)) this.selectSize(tam);
      }
      this.refresh();
    }

    /* ---------------- Versão (com/sem bolso) ---------------- */
    buildVersao() {
      const v = this.passo.versao;
      if (!v || !v.handleAlt) {
        this.versaoEl.hidden = true;
        this.versaoEl.innerHTML = '';
        return;
      }
      const ativo =
        '<button type="button" class="tp-versao__opt is-ativa" aria-pressed="true" disabled>' +
        escapaHtml(v.rotuloAtual) + '</button>';
      const outro =
        '<button type="button" class="tp-versao__opt" aria-pressed="false" data-qb-versao-trocar>' +
        escapaHtml(v.rotuloAlt) + '<span class="tp-versao__spin" aria-hidden="true"></span></button>';
      this.versaoEl.hidden = false;
      this.versaoEl.innerHTML =
        '<p class="tp-qb__label"><span>Versão</span></p>' +
        '<div class="tp-versao__opcoes" role="group" aria-label="Escolha a versão da peça">' +
        (v.atualPrimeiro ? ativo + outro : outro + ativo) +
        '</div>';
    }

    trocarVersao(botao) {
      const ps = this.passo;
      const v = ps.versao;
      if (!v || !v.handleAlt || this.ocupado) return;
      this.ocupado = true;
      botao.setAttribute('aria-busy', 'true');
      this.clearError();
      const antes = { color: this.selectedColor, size: this.selectedSize };
      this.buscarProduto(v.handleAlt)
        .then((nova) => {
          /* Os papéis se invertem no talão, e `atualPrimeiro` inverte junto: os
             dois botões ficam na MESMA posição física depois da troca. O talão
             que vem embutido no produto buscado já sai assim (tp-versao-stub). */
          const talao = nova.versao && nova.versao.handleAlt ? nova.versao : {
            rotuloAtual: v.rotuloAlt,
            rotuloAlt: v.rotuloAtual,
            atualPrimeiro: !v.atualPrimeiro,
            handleAtual: v.handleAlt,
            handleAlt: v.handleAtual || ps.hub.handle
          };
          ps.hub = nova;
          ps.data = nova;
          ps.versao = talao;
          this.aplicarProduto(antes);
          this.preCarregar();
        })
        .catch((err) => {
          console.error('[tp-quick-buy] falha ao trocar de versão', err);
          botao.removeAttribute('aria-busy');
          this.showError('Não foi possível carregar a outra versão. Tente de novo.');
        })
        .finally(() => { this.ocupado = false; });
    }

    /* ---------------- Cores ---------------- */
    /* Fileira = cores do hub e, depois de uma linha fina, as da cor ligada.
       Cada bolinha sabe de que produto é (data-handle). O grupo com rótulo
       (ex.: "Lançamento") ganha contorno coral e a etiqueta, como na PDP. */
    buildColors() {
      const ps = this.passo;
      const d = ps.data;
      this.colorsEl.innerHTML = '';
      if (this.colorIndex < 0 || !(d.colors || []).length) {
        this.colorGroup.hidden = true;
        return;
      }
      const grupos = [{ handle: ps.hub.handle, rotulo: ps.hub.rotuloCor, cores: ps.hub.colors || [] }];
      const cl = ps.hub.corLigada;
      if (cl && cl.handle && (cl.colors || []).length) {
        grupos.push({ handle: cl.handle, rotulo: cl.rotulo, cores: cl.colors });
      }
      const total = grupos.reduce((s, g) => s + g.cores.length, 0);
      // Uma cor só e nenhuma ligada: não há o que escolher, fica só o nome.
      this.colorGroup.hidden = false;
      this.colorGroup.classList.toggle('is-unica', total <= 1);
      this.colorsEl.classList.toggle('has-ligada', grupos.length > 1);

      grupos.forEach((g, gi) => {
        if (gi > 0) {
          const sep = document.createElement('span');
          sep.className = 'tp-qb__color-sep';
          sep.setAttribute('aria-hidden', 'true');
          this.colorsEl.appendChild(sep);
        }
        g.cores.forEach((c) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'tp-qb__color';
          btn.setAttribute('role', 'radio');
          btn.dataset.value = c.name;
          btn.dataset.handle = g.handle || '';
          btn.title = c.name;
          btn.setAttribute('aria-label', c.name + (c.disp === false ? ' (esgotada)' : ''));
          /* Amostra em imagem vai na camada de cima, com a cor pelo nome por
             baixo (cobre o .png que não existe). Amostra em COR (rgb) vai direto
             na camada de cor: cor não pode ser camada de cima num background
             com várias camadas, e a regra inteira cairia. */
          if (c.bg && c.bg.indexOf('url(') === 0) {
            btn.style.setProperty('--qb-swatch', c.bg);
            btn.style.setProperty('--qb-swatch-cor', hexDaCor(c.name));
          } else {
            btn.style.setProperty('--qb-swatch-cor', c.bg || hexDaCor(c.name));
          }
          if (c.disp === false) btn.classList.add('is-esgotada');
          if (g.rotulo) {
            btn.classList.add('is-destaque');
            const em = document.createElement('em');
            em.textContent = g.rotulo;
            btn.appendChild(em);
          }
          btn.appendChild(document.createElement('i'));
          this.colorsEl.appendChild(btn);
        });
      });
    }

    escolherCor(sw) {
      if (this.ocupado) return;
      const ps = this.passo;
      const handle = sw.dataset.handle;
      const cor = sw.dataset.value;
      if (!handle || handle === ps.data.handle) {
        this.selectColor(cor);
        this.refresh();
        return;
      }
      // Cor de OUTRO produto (cor ligada, ou volta ao hub).
      const tamanho = this.selectedSize;
      const aplicar = (prod) => {
        ps.data = prod;
        this.aplicarProduto({ color: cor, size: tamanho, forcar: true });
      };
      if (handle === ps.hub.handle) {
        aplicar(ps.hub);
        return;
      }
      this.ocupado = true;
      sw.setAttribute('aria-busy', 'true');
      this.buscarProduto(handle)
        .then(aplicar)
        .catch((err) => {
          console.error('[tp-quick-buy] falha ao carregar a cor ligada', err);
          sw.removeAttribute('aria-busy');
          this.showError('Não foi possível carregar essa cor. Tente de novo.');
        })
        .finally(() => { this.ocupado = false; });
    }

    corDisponivel(nome) {
      return (this.data.variants || []).some((v) => v.options[this.colorIndex] === nome && v.available);
    }

    firstAvailableColor() {
      const colors = this.data.colors || [];
      for (const c of colors) {
        if (this.corDisponivel(c.name)) return c.name;
      }
      return colors.length ? colors[0].name : null;
    }

    selectColor(value) {
      this.selectedColor = value;
      const h = this.data.handle || '';
      this.colorsEl.querySelectorAll('.tp-qb__color').forEach((el) => {
        const on = el.dataset.value === value && (!el.dataset.handle || el.dataset.handle === h);
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        el.removeAttribute('aria-busy');
      });
      this.colorCurrentEl.textContent = value || '';
      this.updateSizeAvailability();
      if (this.selectedSize && !this.isComboAvailable(value, this.selectedSize)) {
        this.selectedSize = null;
        this.sizesEl.querySelectorAll('.tp-qb__size').forEach((el) => {
          el.classList.remove('is-selected');
          el.setAttribute('aria-checked', 'false');
        });
      }
      this.mostrarCor(value);
    }

    /* ---------------- Galeria ----------------
       Igual à PDP: a faixa tem TODAS as fotos do produto, na ordem do admin, e
       escolher uma cor ROLA (com animação) até a primeira foto daquela cor. A
       galeria só é remontada quando muda o produto cujas fotos estão na tela
       (troca de versão, outro produto no look); aí o salto é direto.

       De quem são as fotos (fonteGaleria):
       - peça de kit (galeriaPai): as da PDP do KIT, na cor equivalente à da
         peça — top e calcinha do biquíni rolam pela mesma galeria do biquíni;
       - cor ligada: as do hub, que já tem as fotos da outra peça (a com Bolso
         tem as da Branca e vice-versa); se não tiver, as do produto da cor;
       - o resto: as do próprio produto. */
    fonteGaleria(cor) {
      const ps = this.passo;
      const d = ps.data;
      if (d.galeriaPai && cor) {
        const nomePai = equivalente((d.galeriaPai.colors || []).map((c) => c.name), cor);
        if (nomePai && this.indiceCor(d.galeriaPai, nomePai) >= 0) return { fonte: d.galeriaPai, cor: nomePai };
      }
      if (ps.hub !== d && cor && this.indiceCor(ps.hub, cor) >= 0) return { fonte: ps.hub, cor: cor };
      return { fonte: d, cor: cor };
    }

    fotosDaFonte(p) {
      return (p.images && p.images.length)
        ? p.images
        : (p.variants || []).map((v) => v.image).filter(Boolean);
    }

    /* Cor de cada foto de `p` (array alinhado com as fotos; null = sem cor).
       1. o nome de uma cor no texto alternativo manda;
       2. foto sem texto fica com a cor cuja foto de variante veio por último
          antes dela (as fotos ficam agrupadas por cor no admin).
       "Conhecidas" inclui as cores ligadas: texto que fala de uma cor de FORA
       (as fotos da Branca copiadas na com Bolso) não cai na cor errada. */
    coresDasFotos(p) {
      if (p._tags) return p._tags;
      const imgs = this.fotosDaFonte(p);
      const cores = (p.colors || []).map((c) => c.name);
      const conhecidas = cores.slice();
      const ps = this.passo;
      [p.corLigada, ps && ps.hub, ps && ps.hub && ps.hub.corLigada, ps && ps.data].forEach((x) => {
        ((x && x.colors) || []).forEach((c) => { if (conhecidas.indexOf(c.name) === -1) conhecidas.push(c.name); });
      });
      const raizes = conhecidas
        .map((n) => ({ n: n, r: raizCor(n) }))
        .sort((a, b) => b.r.length - a.r.length); // "preto canelado" antes de "preto"
      const titulo = normaliza(p.titleRaw || '');
      const alts = p.imageAlts || [];
      const inicio = {};
      (p.colors || []).forEach((c) => {
        if (c.img) inicio[semUrlQuery(c.img)] = c.name;
      });
      let atual = null;
      // Fotos antes da 1ª foto de variante ficam com a cor que começa mais cedo.
      for (let k = 0; k < imgs.length && atual === null; k++) {
        if (inicio[semUrlQuery(imgs[k])]) atual = inicio[semUrlQuery(imgs[k])];
      }
      const tags = imgs.map((src, k) => {
        let tag = null;
        const alt = normaliza(alts[k] || '');
        if (alt && alt !== titulo) {
          const achou = raizes.find((x) => alt.indexOf(x.r) !== -1);
          if (achou) tag = achou.n;
        }
        const comeca = inicio[semUrlQuery(src)];
        if (comeca) atual = comeca;
        if (tag === null) tag = atual;
        else if (cores.indexOf(tag) !== -1) atual = tag;
        return tag;
      });
      try { Object.defineProperty(p, '_tags', { value: tags, configurable: true }); } catch (e) { /* nada */ }
      return tags;
    }

    // Índice da 1ª foto da cor em `p`, ou -1.
    indiceCor(p, cor) {
      if (!cor) return -1;
      const n = normaliza(cor);
      const tags = this.coresDasFotos(p);
      for (let k = 0; k < tags.length; k++) {
        if (tags[k] && normaliza(tags[k]) === n) return k;
      }
      return -1;
    }

    mostrarCor(cor) {
      const g = this.fonteGaleria(cor);
      let animar = true;
      if (g.fonte !== this.galeriaAtual) {
        this.buildGallery(g.fonte);
        animar = false;
      }
      const k = this.indiceCor(g.fonte, g.cor);
      if (k >= 0) this.irParaFoto(k, animar);
    }

    buildGallery(fonte) {
      const fotos = this.fotosDaFonte(fonte);
      this.galeriaAtual = fonte;
      this.fotos = fotos;
      this.trackEl.innerHTML = '';
      this.thumbsEl.innerHTML = '';
      const nome = this.data.title || '';
      fotos.forEach((src, k) => {
        const fig = document.createElement('div');
        fig.className = 'tp-qb__slide';
        const img = document.createElement('img');
        img.src = src;
        img.alt = k === 0 ? nome : '';
        img.loading = k < 2 ? 'eager' : 'lazy';
        img.decoding = 'async';
        fig.appendChild(img);
        this.trackEl.appendChild(fig);

        const t = document.createElement('button');
        t.type = 'button';
        t.className = 'tp-qb__thumb';
        t.dataset.i = k;
        t.setAttribute('aria-label', 'Foto ' + (k + 1));
        t.innerHTML = '<img src="' + escapaHtml(src) + '" alt="" loading="lazy">';
        this.thumbsEl.appendChild(t);
      });
      this.classList.toggle('has-1-foto', fotos.length < 2);
      this.trackEl.scrollLeft = 0;
      this.fotoAtual = 0;
      this.fotoPendente = null;
      this.marcarFotoAtual();
    }

    larguraSlide() {
      const s = this.trackEl.querySelector('.tp-qb__slide');
      if (!s) return 1;
      const gap = parseFloat(getComputedStyle(this.trackEl).columnGap) || 0;
      return s.getBoundingClientRect().width + gap;
    }

    /* Com o pop-up ainda escondido as larguras são zero e a conta dá NaN — por
       isso o showSheet chama isto de novo depois que a janela aparece. */
    marcarFotoAtual() {
      const n = (this.fotos || []).length;
      const larg = this.larguraSlide();
      const i = n && larg > 1 ? Math.min(n - 1, Math.max(0, Math.round(this.trackEl.scrollLeft / larg))) : 0;
      this.fotoAtual = i;
      let ativa = null;
      this.thumbsEl.querySelectorAll('.tp-qb__thumb').forEach((t, k) => {
        t.classList.toggle('is-active', k === i);
        if (k === i) ativa = t;
      });
      // Miniatura ativa sempre à vista na fileira (só a fileira rola, nunca a página).
      if (ativa && this.thumbsEl.clientWidth) {
        const esq = ativa.offsetLeft - this.thumbsEl.children[0].offsetLeft;
        if (esq < this.thumbsEl.scrollLeft || esq + ativa.offsetWidth > this.thumbsEl.scrollLeft + this.thumbsEl.clientWidth) {
          this.thumbsEl.scrollTo({ left: Math.max(0, esq - 8), behavior: 'smooth' });
        }
      }
      const fim = this.trackEl.clientWidth > 0 &&
        this.trackEl.scrollLeft + this.trackEl.clientWidth >= this.trackEl.scrollWidth - 2;
      this.navPrev.hidden = n < 2 || i <= 0;
      this.navNext.hidden = n < 2 || fim;
    }

    /* Leva a faixa até a foto `i`. O scroll-snap obrigatório faz o Chromium
       cancelar rolagem feita por código no meio do caminho, então o snap sai
       durante a rolagem e volta no fim. Pop-up ainda escondido (larguras zero):
       guarda e o showSheet salta para lá quando a janela aparece. */
    irParaFoto(i, animar) {
      const n = (this.fotos || []).length;
      if (!n) return;
      const k = Math.max(0, Math.min(n - 1, i));
      const t = this.trackEl;
      const slide = t.children[k];
      if (!slide || !t.clientWidth) {
        this.fotoPendente = k;
        return;
      }
      this.fotoPendente = null;
      const esquerda = slide.offsetLeft - t.children[0].offsetLeft;
      const suave = animar !== false &&
        !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      t.style.scrollSnapType = 'none';
      clearTimeout(this.snapTimer);
      if (!suave) {
        t.scrollLeft = esquerda;
        this.snapTimer = setTimeout(() => { t.style.scrollSnapType = ''; this.marcarFotoAtual(); }, 30);
        return;
      }
      /* Cor longe (ex.: da 1ª para a 27ª foto): salta para perto e anima só as
         últimas fotos. Rolar 26 fotos inteiras vira um borrão e demora. */
      const larg = this.larguraSlide();
      const perto = 2 * larg;
      if (larg > 1 && Math.abs(esquerda - t.scrollLeft) > perto * 1.5) {
        t.scrollLeft = esquerda > t.scrollLeft ? esquerda - perto : esquerda + perto;
      }
      t.scrollTo({ left: esquerda, behavior: 'smooth' });
      /* O snap só volta quando a rolagem PARA (chegou no alvo ou ficou parada
         dois tempos seguidos). Com tempo fixo ele voltava no meio do caminho e
         a faixa encaixava na cor errada. 'scrollend' não existe em todo Safari. */
      let ultimo = -1;
      let parado = 0;
      let voltas = 0;
      const conferir = () => {
        const x = t.scrollLeft;
        voltas++;
        if (x === ultimo) parado++; else parado = 0;
        ultimo = x;
        if (Math.abs(x - esquerda) < 2 || parado >= 2 || voltas > 40) {
          t.style.scrollSnapType = '';
          this.marcarFotoAtual();
          return;
        }
        this.snapTimer = setTimeout(conferir, 80);
      };
      this.snapTimer = setTimeout(conferir, 80);
    }

    passarFoto(delta) {
      this.irParaFoto((this.fotoAtual || 0) + delta, true);
    }

    /* ---------------- Tamanhos ---------------- */
    listaTamanhos() {
      const seen = [];
      (this.data.variants || []).forEach((v) => {
        const val = v.options[this.sizeIndex];
        if (val != null && seen.indexOf(val) === -1) seen.push(val);
      });
      return seen;
    }

    buildSizes() {
      this.sizesEl.innerHTML = '';
      if (this.singleVariant || this.sizeIndex < 0) { this.sizeGroup.hidden = true; return; }
      const lista = this.listaTamanhos();
      if (!lista.length) { this.sizeGroup.hidden = true; return; }
      this.sizeGroup.hidden = false;
      this.sizesEl.style.setProperty('--qb-cols', Math.min(lista.length, 5));
      let temSub = false;
      lista.forEach((val) => {
        const p = partesTamanho(val);
        if (p.sub) temSub = true;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tp-qb__size';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.dataset.value = val;
        btn.setAttribute('aria-label', 'Tamanho ' + val);
        btn.innerHTML = '<b>' + escapaHtml(p.main) + '</b>' + (p.sub ? '<small>' + escapaHtml(p.sub) + '</small>' : '');
        this.sizesEl.appendChild(btn);
      });
      this.sizesEl.classList.toggle('has-sub', temSub);
    }

    selectSize(value) {
      this.selectedSize = value;
      this.sizesEl.querySelectorAll('.tp-qb__size').forEach((el) => {
        const on = el.dataset.value === value;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.hintEl.hidden = true;
      this.sizeGroup.classList.remove('is-chamando');
      this.refresh();
    }

    updateSizeAvailability() {
      if (this.sizeIndex < 0) return;
      this.sizesEl.querySelectorAll('.tp-qb__size').forEach((el) => {
        const size = el.dataset.value;
        const avail = this.colorIndex >= 0 && this.selectedColor
          ? this.isComboAvailable(this.selectedColor, size)
          : (this.data.variants || []).some((v) => v.options[this.sizeIndex] === size && v.available);
        el.classList.toggle('is-unavailable', !avail);
        el.setAttribute('aria-disabled', avail ? 'false' : 'true');
        el.title = avail ? '' : 'Esgotado nesta cor';
      });
    }

    isComboAvailable(color, size) {
      return (this.data.variants || []).some((v) => {
        const colorOk = this.colorIndex < 0 || v.options[this.colorIndex] === color;
        const sizeOk = this.sizeIndex < 0 || v.options[this.sizeIndex] === size;
        return colorOk && sizeOk && v.available;
      });
    }

    matchVariant() {
      const variants = (this.data && this.data.variants) || [];
      if (this.singleVariant) return variants[0] || null;
      return variants.find((v) => {
        const colorOk = this.colorIndex < 0 || v.options[this.colorIndex] === this.selectedColor;
        const sizeOk = this.sizeIndex < 0 || v.options[this.sizeIndex] === this.selectedSize;
        return colorOk && sizeOk;
      }) || null;
    }

    pedirTamanho() {
      if (this.sizeIndex < 0 || this.sizeGroup.hidden) return;
      if (this.colorIndex >= 0 && this.selectedColor && !this.corDisponivel(this.selectedColor)) return;
      this.hintEl.hidden = false;
      this.sizeGroup.classList.remove('is-chamando');
      void this.sizeGroup.offsetWidth;
      this.sizeGroup.classList.add('is-chamando');
      const alvo = this.sizeGroup.offsetTop - 8;
      if (alvo < this.scrollEl.scrollTop || alvo > this.scrollEl.scrollTop + this.scrollEl.clientHeight - 80) {
        this.scrollEl.scrollTo({ top: alvo, behavior: 'smooth' });
      }
    }

    /* ---------------- Preço + botão ---------------- */
    refresh() {
      const d = this.data;
      const variant = this.matchVariant();
      const variants = d.variants || [];
      let fonte = variant;
      if (!fonte && this.colorIndex >= 0 && this.selectedColor) {
        fonte = variants.find((v) => v.options[this.colorIndex] === this.selectedColor && v.available)
          || variants.find((v) => v.options[this.colorIndex] === this.selectedColor);
      }
      if (!fonte) fonte = variants.find((v) => v.available) || variants[0] || null;
      this.mostrarPreco(fonte);

      const isLast = this.mode !== 'sequence' || this.stepIndex >= this.passos.length - 1;
      const corEsgotada = this.colorIndex >= 0 && this.selectedColor && !this.corDisponivel(this.selectedColor);
      this.variantInput.value = variant ? variant.id : '';
      this.addBtn.classList.remove('is-esgotado');
      this.addBtn.removeAttribute('aria-disabled');
      this.addBtn.disabled = false;

      if (variant && !variant.available) {
        // AVISE-ME (19/10/2026): o botão segue ativo e só troca o texto
        this.addLabel.textContent = window.tpAviseMe ? window.tpAviseMe.rotulo(variant.id) : 'Avise-me quando chegar';
      } else if (corEsgotada) {
        this.addBtn.disabled = true;
        this.addBtn.classList.add('is-esgotado');
        this.addLabel.textContent = 'Esgotado nesta cor';
      } else {
        this.addLabel.textContent = isLast ? 'Adicionar ao carrinho' : 'Próxima peça →';
      }
    }

    mostrarPreco(v) {
      const d = this.data;
      if (!v) {
        this.priceMainEl.textContent = '';
        this.priceCompareEl.hidden = true;
        this.parcEl.hidden = true;
        this.cupomEl.hidden = true;
        return;
      }
      let cents = typeof v.priceCents === 'number' ? v.priceCents : centavosDe(v.price);
      // TESTE DE PREÇO (VWO): preço do grupo da cliente (ver snippets/tp-teste-preco.liquid)
      const centsTeste = window.tpTestePreco && cents != null ? window.tpTestePreco.preco(d.handle, cents) : cents;
      // grupo "semRiscado" (UTM da Meta): o preço do grupo aparece como preço normal
      let compareTxt = centsTeste !== cents && window.tpTestePreco.semRiscado() ? null : (v.comparePrice || null);
      let mainTxt = centsTeste !== cents ? dinheiro(centsTeste) : (v.price || dinheiro(cents));
      cents = centsTeste;

      // Desconto progressivo: "de" é o preço da peça e "por" o de 1 peça (como no card).
      const prog = d.prog && d.prog.pct > 0 ? d.prog : null;
      if (prog && cents != null) {
        const progCents = Math.floor(((100 - prog.pct) * cents + 50) / 100);
        compareTxt = dinheiro(cents);
        cents = progCents;
        mainTxt = dinheiro(progCents);
      }

      this.priceMainEl.textContent = mainTxt;
      this.priceMainEl.classList.toggle('is-sale', !!compareTxt);
      if (compareTxt) {
        this.priceCompareEl.textContent = compareTxt;
        this.priceCompareEl.hidden = false;
      } else {
        this.priceCompareEl.hidden = true;
      }

      const parc = this.textoParcelas(cents);
      this.parcEl.textContent = parc || '';
      this.parcEl.hidden = !parc;

      if (prog && prog.cupom > 0 && cents != null) {
        const comCupom = Math.floor(((100 - prog.cupom) * cents + 50) / 100);
        this.cupomEl.innerHTML = '<b>' + dinheiro(comCupom) + '</b> ' + escapaHtml(prog.cupomTxt || 'com o cupom');
        this.cupomEl.hidden = false;
      } else {
        this.cupomEl.hidden = true;
      }
    }

    // Mesma regra do snippets/tp-installments.liquid.
    textoParcelas(cents) {
      const p = this.data.parc;
      if (!p || cents == null) return '';
      if (p.n > 1) return p.n + 'x de ' + dinheiro(Math.floor(cents / p.n)) + ' sem juros';
      if (p.n === 1 || !p.on) return '';
      for (let n = p.max; n >= 2; n--) {
        const v = Math.floor(cents / n);
        if (v >= p.min) return n + 'x de ' + dinheiro(v) + ' sem juros';
      }
      return '';
    }

    /* ---------------- Sequência (kit / look) ---------------- */
    avancar() {
      const variant = this.matchVariant();
      if (!variant || !variant.available) return;
      this.collected[this.stepIndex] = { id: variant.id, color: this.selectedColor, size: this.selectedSize };
      if (this.stepIndex < this.passos.length - 1) {
        /* Próxima peça abre na MESMA COR da que acabou de ser escolhida (top
           preto → calcinha preta), se existir e estiver disponível. Quem já
           passou por ela e voltou encontra o que tinha escolhido. */
        const prox = this.collected[this.stepIndex + 1];
        this.mostrarPasso(this.stepIndex + 1, prox ? { color: prox.color, size: prox.size } : { color: this.selectedColor });
      } else {
        this.addSequenceToCart();
      }
    }

    voltar() {
      if (this.stepIndex <= 0) return;
      // O que já estava escolhido aqui fica guardado para quando ela voltar.
      const v = this.matchVariant();
      this.collected[this.stepIndex] = v ? { id: v.id, color: this.selectedColor, size: this.selectedSize } : null;
      const ant = this.collected[this.stepIndex - 1];
      this.mostrarPasso(this.stepIndex - 1, ant ? { color: ant.color, size: ant.size } : null);
    }

    addSequenceToCart() {
      // Um kit pode repetir a mesma peça (ex.: leve 2 leggings e ganhe a
      // regata). Se a cliente escolher a MESMA variante nos dois passos,
      // somamos: uma linha com quantidade 2, em vez de duas linhas de 1.
      const items = [];
      const porVariante = {};
      this.collected.slice(0, this.passos.length).forEach((c) => {
        if (!c || !c.id) return;
        const k = String(c.id);
        if (porVariante[k]) {
          porVariante[k].quantity += 1;
          return;
        }
        const item = { id: c.id, quantity: 1 };
        if (this.kitProperty) {
          item.properties = {};
          item.properties[this.kitProperty] = this.kitName || 'Kit';
        }
        porVariante[k] = item;
        items.push(item);
      });
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      this.setAdding(true);
      this.clearError();
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((res) => {
          if (res && res.status) {
            this.showError(res.description || res.message || 'Não foi possível adicionar ao carrinho.');
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
            this.close();
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => this.showError('Não foi possível adicionar ao carrinho.'))
        .finally(() => this.setAdding(false));
    }

    setAdding(on) {
      this.addBtn.classList.toggle('loading', on);
      this.addBtn.disabled = on;
      const sp = this.addBtn.querySelector('.loading__spinner');
      if (sp) sp.classList.toggle('hidden', !on);
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorWrap.hidden = false;
    }

    clearError() {
      this.errorWrap.hidden = true;
      this.errorEl.textContent = '';
    }

    /* ---------------- Guia de medidas (abas) ---------------- */
    // Produto de onde sai a ajuda: a peça, ou o kit pai quando a peça não tem.
    fonteGuia() {
      const d = this.data;
      return d.guiaHandle || d.handle;
    }

    flagsGuia() {
      const d = this.data;
      return {
        tabela: !!(d.temTabela || (d.sizeGuide && String(d.sizeGuide).trim())),
        peca: !!(d.temPeca || (d.medidasPeca && String(d.medidasPeca).trim())),
        modelos: !!(d.temModelos || (d.modelosReais && String(d.modelosReais).trim()))
      };
    }

    atualizarBotaoGuia() {
      const f = this.flagsGuia();
      this.helpBtn.hidden = !(f.tabela || f.peca || f.modelos);
    }

    abrirGuia() {
      const f = this.flagsGuia();
      const abas = [];
      if (f.tabela) abas.push(['tabela', 'Tabela']);
      if (f.peca) abas.push(['peca', 'Medidas da peça']);
      if (f.modelos) abas.push(['modelos', 'Modelos reais']);
      if (!abas.length) return;
      this.helpTabsEl.innerHTML = abas.length > 1
        ? abas.map((a) => '<button type="button" role="tab" class="tp-qb__aba" data-qb-aba="' + a[0] + '">' + a[1] + '</button>').join('')
        : '';
      this.helpTabsEl.hidden = abas.length < 2;
      if (this.helpEl.hidden) this.empilharHistorico();
      this.helpEl.hidden = false;
      this.classList.add('is-guia');
      this.mostrarAba(abas[0][0]);
      const back = this.helpEl.querySelector('[data-qb-help-close]');
      if (back) back.focus({ preventScroll: true });
    }

    // `porHistorico`: veio do voltar (a entrada já saiu) ou do close(), que tira tudo de uma vez.
    fecharGuia(porHistorico) {
      if (!this.helpEl || this.helpEl.hidden) return;
      if (!porHistorico && this.niveisHist >= 2) this.desempilharHistorico(1);
      this.helpEl.hidden = true;
      this.classList.remove('is-guia');
      this.helpBodyEl.innerHTML = '';
      if (this.helpBtn && !this.helpBtn.hidden) this.helpBtn.focus({ preventScroll: true });
    }

    mostrarAba(aba) {
      this.helpTabsEl.querySelectorAll('[data-qb-aba]').forEach((t) => {
        const on = t.dataset.qbAba === aba;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.abaAtual = aba;
      const campo = aba === 'tabela' ? 'sizeGuide' : aba === 'peca' ? 'medidasPeca' : 'modelosReais';
      const d = this.data;
      const local = d[campo] && String(d[campo]).trim() ? d[campo] : null;
      if (local) { this.pintarAba(aba, local); return; }

      this.helpBodyEl.innerHTML = '<p class="tp-qb__help-load">Carregando…</p>';
      this.buscarProduto(this.fonteGuia())
        .then((full) => {
          if (this.helpEl.hidden || this.abaAtual !== aba) return;
          this.pintarAba(aba, full[campo] || '');
        })
        .catch(() => {
          if (this.abaAtual !== aba) return;
          this.helpBodyEl.innerHTML = '<p class="tp-qb__help-load">Não foi possível carregar. <a href="' +
            escapaHtml(d.url || '#') + '">Ver na página do produto</a></p>';
        });
    }

    pintarAba(aba, html) {
      if (aba === 'peca') this.carregarCssPeca();
      this.helpBodyEl.innerHTML = html || '<p class="tp-qb__help-load">Conteúdo não cadastrado para esta peça.</p>';
      this.helpBodyEl.scrollTop = 0;
      if (aba === 'tabela') this.rodarScripts(this.helpBodyEl);
    }

    carregarCssPeca() {
      const href = this.dataset.cssPeca;
      if (!href || document.querySelector('link[data-qb-css-peca]')) return;
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.setAttribute('data-qb-css-peca', '');
      document.head.appendChild(l);
    }

    /* A tabela do metacampo traz um <script> que procura os próprios elementos
       com document.getElementById (ex.: o seletor com/sem bolso da LipLegging).
       Numa PDP a mesma tabela já existe na janela da página, com os MESMOS ids,
       e o script do pop-up acabava mexendo na tabela de lá. Aqui o script roda
       com um `document` de mentira que só enxerga o conteúdo do pop-up. */
    rodarScripts(raiz) {
      const doc = {
        getElementById: (id) => raiz.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id)),
        querySelector: (s) => raiz.querySelector(s),
        querySelectorAll: (s) => raiz.querySelectorAll(s),
        createElement: (t) => document.createElement(t),
        addEventListener: () => {},
        body: raiz,
        documentElement: raiz
      };
      raiz.querySelectorAll('script').forEach((velho) => {
        if (velho.src) return;
        try {
          new Function('document', velho.textContent)(doc);
        } catch (err) {
          console.error('[tp-quick-buy] script da tabela de medidas falhou', err);
        }
        velho.remove();
      });
    }
  }

  customElements.define('tp-quick-buy', TpQuickBuy);
})();
